import { render, staticRenderFns } from "./AuditLogsDetail.vue?vue&type=template&id=d4225a8a&"
import script from "./AuditLogsDetail.vue?vue&type=script&lang=ts&"
export * from "./AuditLogsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLogsDetail.vue?vue&type=style&index=0&id=d4225a8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports